export function nopropagation(event) {
  event.stopImmediatePropagation();
}

export default function(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-brush/src/noevent.js
// module id = 445
// module chunks = 0